import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/construct-x/shared/shared.module";
import { CertificatesComponent } from './components/certificates/certificates.component';

@NgModule({
  imports: [
    CertificatesComponent,
    SharedModule
  ],
  exports: [
    CertificatesComponent
  ]
})
export class CertificatesModule { }